import { db } from "../firebase-config";
import { collection, query, where, getDocs, getDoc, setDoc, updateDoc, doc } from "firebase/firestore";

// Fetch a specific time sheet for a user by path and week start date
export const fetchTimeSheetsForWeek = async (user, path, weekStart) => {

  const docPath = `organizations/${user.organization}/time_sheets/${path}`;
  const docRef = doc(db, docPath);

  try {
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() };
    } else {
      return {
        "daily_hours": {},
        "employee_id": user.uid,
        "total_hours": 0,
        "week_starting": weekStart,
        "status": null
      };
    }
  } catch (error) {
    console.error("Error fetching document:", error);
    throw error;
  }
};

// Add a new time sheet
export const addTimeSheet = async (organizationId, timeSheetDocument) => {
  const docPath = `organizations/${organizationId}/time_sheets/${timeSheetDocument.id}`;
  const docRef = doc(db, docPath);

  try {
    await setDoc(docRef, timeSheetDocument);
    return { success: true, error: null };
  } catch (error) {
    console.error("Error saving timesheet:", error);
    return { success: false, error: error.message };
  }
};

// Update the status of an existing timesheet
export const updateTimesheetStatus = async (organizationId, timesheetId, newStatus) => {
  const docPath = `organizations/${organizationId}/time_sheets/${timesheetId}`;
  const docRef = doc(db, docPath);

  try {
    await updateDoc(docRef, { status: newStatus });
    return { success: true, error: null };
  } catch (error) {
    console.error("Error updating timesheet status:", error);
    return { success: false, error: error.message };
  }
};

// Fetch timesheets for review based on specific statuses

export const fetchTimesheetsForReview = async (organizationId, weekString) => {
  const collectionPath = `organizations/${organizationId}/time_sheets`;
  try {
    const q = query(
      collection(db, collectionPath),
      where("status", "in", ["Submitted", "Approved", "Rejected"]) // Using the "in" operator to filter by multiple statuses
    );

    const querySnapshot = await getDocs(q);
    const timeSheets = [];

    querySnapshot.forEach((doc) => {
      timeSheets.push({ id: doc.id, ...doc.data() });
    });

    return timeSheets;
  } catch (error) {
    console.error("Error fetching submitted time sheets for week:", error);
    throw error; 
  }
};
